import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { SaveParams } from "utils";
import { Box, Tab, Tabs } from "@mui/material";

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { boxClassName, children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={boxClassName} p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const TabMain = ({
  className,
  classNameTabs,
  defaultTab,
  tabsLabels,
  tabsContent,
  besideTheTab,
  getTab,
}) => {
  const [value, setValue] = useState(defaultTab);
  const navigate = useNavigate();
  const location = useLocation();
  const info = location?.state;

  useEffect(() => {
    if (info?.activeTab) {
      setValue(info?.activeTab);
    }
  }, [info]);

  const handleChange = (newValue) => {
    setValue(newValue);
    const anotherInfo = {
      ...info,
      activeTab: newValue,
    };
    delete anotherInfo.sortType;
    delete anotherInfo.type;
    delete anotherInfo.status;
    if (getTab) {
      getTab(newValue);
    } else {
      SaveParams(location?.pathname, navigate, { ...anotherInfo });
    }
  };

  return (
    <div className={`main-tabs-wrapper ${className ? className : ""}`}>
      <div className={`main-tabs-box ${classNameTabs ? classNameTabs : ""}`}>
        <Tabs
          value={value}
          className={`main-tabs-block`}
          indicatorColor="transparent"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
        >
          {tabsLabels &&
            tabsLabels.map((tabLabel, index) => {
              if (tabLabel) {
                return (
                  <Tab
                    key={index}
                    onClick={() => {
                      handleChange(tabLabel?.label);
                    }}
                    // className={tabStyle.tabLabel}
                    label={tabLabel?.label}
                    value={tabLabel?.label}
                    {...a11yProps(tabLabel?.label)}
                  />
                );
              }
            })}
        </Tabs>

        {besideTheTab}
      </div>

      {tabsContent &&
        tabsContent.map((tabContent, index) => {
          if (tabContent && tabContent?.tab === value) {
            return (
              <TabPanel
                key={index}
                index={tabContent?.tab}
                value={tabContent?.tab}
                active={tabContent?.tab}
                boxClassName={"tab-panel-wrapper"}
              >
                {tabContent?.tabComponent}
              </TabPanel>
            );
          }
        })}
    </div>
  );
};
